import { AccessResult } from "utils/access";

import { TEMPLATE_DEPLOYMENT_MESSAGE } from "./constants";

type StackWithTemplateDeployment = {
  isLockedByTemplateDeployment: boolean;
};

export const checkTemplateDeploymentAccess = (
  stack?: StackWithTemplateDeployment
): AccessResult | undefined => {
  if (stack?.isLockedByTemplateDeployment) {
    return { result: false, message: TEMPLATE_DEPLOYMENT_MESSAGE };
  }
  return undefined;
};
